<script setup>
</script>

<template>
  <div class="flex justify-center items-center text-blue-500 h-full">
    <IconHawkLoadingCircle class="animate-spin h-7 w-7" />
  </div>
</template>
